import { render, staticRenderFns } from "./checkbox-cell-renderer.vue?vue&type=template&id=b1a87e3c"
import script from "./checkbox-cell-renderer.vue?vue&type=script&lang=js"
export * from "./checkbox-cell-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports